import React from "react";
import { LanguageCode } from "../../utils/translations";
import { getUseCase } from "../../features/usecases/useCaseContent";

interface MultipleInstagramAccountsProps {
  lang?: LanguageCode;
}

const MultipleInstagramAccounts: React.FC<MultipleInstagramAccountsProps> = ({
  lang = "en",
}) => {
  const content = getUseCase(lang, "instagram");

  return (
    <div style={{ padding: "40px 8%", maxWidth: "1000px", margin: "auto" }}>
      {/* H1 */}
      <h1 style={{ fontSize: "2.2rem", fontWeight: 800 }}>
        {content.title}
      </h1>

      {/* Intro */}
      <p style={{ marginTop: "16px", lineHeight: "1.7" }}>
        {content.intro}
      </p>

      {content.sections.map((section) => (
        <React.Fragment key={section.heading}>
          {/* Section */}
          <h2 style={{ marginTop: "30px" }}>{section.heading}</h2>
          {section.body && <p>{section.body}</p>}
          {section.items && (
            <ul>
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </React.Fragment>
      ))}

      {/* CTA */}
      {content.cta && (
        <div style={{ marginTop: "40px", textAlign: "center" }}>
          <button
            style={{
              backgroundColor: "#00B894",
              color: "white",
              padding: "12px 30px",
              borderRadius: "8px",
              border: "none",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {content.cta}
          </button>
        </div>
      )}
    </div>
  );
};

export default MultipleInstagramAccounts;
